import { render } from "./BroadcastQueue.vue?vue&type=template&id=6ba59676&scoped=true"
import script from "./BroadcastQueue.vue?vue&type=script&lang=js"
export * from "./BroadcastQueue.vue?vue&type=script&lang=js"

import "./BroadcastQueue.vue?vue&type=style&index=0&id=6ba59676&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba59676"]])

export default __exports__